import * as React from 'react';

function usePasswordVisibility() {
  const [showPassword, setShowPassword] = React.useState(false);

  function togglePasswordVisibility() {
    setShowPassword(function (prev) {
      return !prev;
    });
  }

  return [showPassword, togglePasswordVisibility] as const;
}

export { usePasswordVisibility };
